import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import api from "./api"
import './assets/iconfont.js';
import "@/assets/global.css"
import { useFavicon } from '@vueuse/core'
import mitt from 'mitt'
import 'swiper/element/bundle'
import { register } from 'swiper/element/bundle'


const get_language = () => {
    let stored_language = localStorage.getItem("language");
    if (stored_language === null) {
      let navigator_language = navigator.language;
      if (navigator_language in ['zh-CN', 'zh-HK', 'zh-TW']) {
          localStorage.setItem("language", navigator_language);
          return navigator_language;
      }
      else {
        localStorage.setItem("language", 'en');
        return 'en';
      }
    }
    else {
      return stored_language;
    }
}


const i18n = createI18n({
    legacy: false, // you must set `false`, to use Composition API // [!code ++]
    locale: get_language()
  })

// swiper
register()

//wechat
const ua = navigator.userAgent.toLowerCase()
const is_wxwork = ua.match(/wxwork/i) == 'wxwork'

//favicon
const favicon = useFavicon()
favicon.value = '/static/favicon_web.png'

var vue = createApp(App)
vue.use(i18n)
vue.use(store)
vue.use(router)

vue.config.globalProperties.$api = api
vue.config.globalProperties.$is_wechat = !is_wxwork && ua.match(/MicroMessenger/i) == 'micromessenger'
vue.config.globalProperties.$emitter = mitt();
vue.mount('#app')
